import { Component, EventEmitter, Input, Output } from '@angular/core';

export interface MultiSelectPillItem {
  id: string;
  label: string;
}

@Component({
  selector: 'multi-select-pills',
  templateUrl: './multi-select-pills.component.html',
  styleUrls: ['./multi-select-pills.component.scss'],
  standalone: false,
})
export class MultiSelectPillsComponent {
  @Input() items: MultiSelectPillItem[] = [];
  @Output() remove = new EventEmitter<string>();

  onRemove(id: string): void {
    this.remove.emit(id);
  }
}
